import { Button, Dialog, DialogBody, DialogFooter } from '@blueprintjs/core';
import SiteDialogData from 'Data/SiteDialogData';
import DataManager from 'Lib/DataManager';
import { useEffect, useState } from 'react';

import styles from './SiteDialogContainer.module.css';

let DM = new DataManager();

/*
  Master dialog popup container. Interacts with individual components via the SiteDialog messaging bus to handle
  the display of messages across the site. Exists to unify notification across the app. Primarily a thin wrapper around
  the BlueprintJS Dialog element.
*/
const SiteDialogContainer = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    DM.add(
      SiteDialogData.registerListener('DIALOG_OPENED', dialogOpened),
      SiteDialogData,
    );
    DM.add(
      SiteDialogData.registerListener('DIALOG_CLOSED', dialogClosed),
      SiteDialogData,
    );
    return () => {
      DM.clear();
    };
  }, []);

  const dialogOpened = () => {
    setDialogOpen(true);
  };

  const dialogClosed = () => {
    setDialogOpen(false);
  };

  const closeDialog = () => {
    SiteDialogData.clear();
    setDialogOpen(false);
  };

  const getCloseButton = () => {
    return (
      SiteDialogData.showCloseInFooter() && (
        <Button
          key={0}
          outlined
          className={styles.close_button}
          onClick={closeDialog}>
          Close
        </Button>
      )
    );
  };

  return (
    <Dialog
      isOpen={dialogOpen}
      onClose={closeDialog}
      title={SiteDialogData.title()}
      icon={SiteDialogData.icon()}>
      <DialogBody>{SiteDialogData.message()}</DialogBody>
      {SiteDialogData.actionButtons()?.length > 0 && (
        <DialogFooter
          className={styles.footer}
          actions={[getCloseButton(), ...SiteDialogData.actionButtons()]}
        />
      )}
    </Dialog>
  );
};

export default SiteDialogContainer;
